module.exports = __webpack_public_path__ + "static/media/ItsNiceThat.9683fea4.png";